var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-container',{staticClass:"bg-white py-4",attrs:{"fluid":""}},[_c('b-row',{staticClass:"d-flex justify-content-center"},[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }